module.exports = __webpack_public_path__ + "img/panturrilha.c433858c.png";